import "./directions_departments.css";
import react, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody'; import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import AddIcon from '@mui/icons-material/Add';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Pagination from "react-js-pagination";
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';

import { makeStyles } from '@mui/styles';
import Loading_animation_view from '../../loading_animation_view/loading_animation_view';
import Add_infos_modal from "./add_infos_modal";
import { get_all_directions, get_all_services, get_departments, get_directions } from "../../../services/company_admin_service";



const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

const directions_columns = [
    { id: 'title', label: "Direction", minWidth: 0 },
    { id: 'director', label: "Directeur", minWidth: 0 },
    { id: 'archived', label: "Statut", minWidth: 0 },
];

const departments_columns = [
    { id: 'title', label: "Département", minWidth: 0 },
    { id: 'direction', label: "Direction", minWidth: 0 },
    { id: 'department_manager', label: "Chef de département", minWidth: 0 },
    { id: 'archived', label: "Statut", minWidth: 0 },
];


function state(archived) {
    return (
        <>
            {
                archived === 1
                    ? <Button variant="contained" className="status_deny">{"archivée"}</Button>
                    : <Button variant="contained" className="status_success">{"non archivée"}</Button>
            }
        </>
    );
}

function get_user_infos(id_user, users) {
    const user_infos = users.filter((usr) => usr.id == id_user);
    return user_infos[0];
}

function get_direction_infos(id_dir, directions) {
    const dir_infos = directions.filter((dir) => dir.id == id_dir);
    return dir_infos[0];
}

function Directions({ directions, archive, setupdate_infos, setadd_infos_modal, users }) {

    return (
        <>
            {
                directions.map((direction, id) => (
                    <TableRow key={"direction" + id}>
                        <TableCell align="left">
                            <div style={{ width: 'fit-content' }}>
                                {direction.title}
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <Tooltip title="modifier" placement="top" >
                                        <span className={"editIcon"} onClick={() => { setupdate_infos(direction); setadd_infos_modal(true) }} >
                                            <EditIcon className="my_icon" style={{ cursor: 'pointer' }} />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        </TableCell>
                        <TableCell align="left">  {get_user_infos(direction.director, users)?.fullName} </TableCell>
                        <TableCell align="center">
                            <div className='documentsStatus_valide'  >
                                <div>
                                    <div><CheckIcon className="checkIcon" onClick={() => archive(id, direction.id, false)} /></div>
                                    <div><CloseSharpIcon className="closeSharpIcon" onClick={() => archive(id, direction.id, true)} /></div>
                                </div>
                                {state(direction.archived)}
                            </div>
                        </TableCell>
                    </TableRow>
                ))
            }
        </>
    );
}


function Departments({ departments, archive, setupdate_infos, setadd_infos_modal, users, all_directions }) {

    return (
        <>
            {
                departments.map((department, id) => (
                    <TableRow key={"direction" + id}>
                        <TableCell align="left">
                            <div style={{ width: 'fit-content' }}>
                                {department.title}
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <Tooltip title="modifier" placement="top" >
                                        <span className={"editIcon"} onClick={() => { setupdate_infos(department); setadd_infos_modal(true) }} >
                                            <EditIcon className="my_icon" style={{ cursor: 'pointer' }} />
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        </TableCell>
                        <TableCell align="left">  {get_direction_infos(department.direction, all_directions).title} </TableCell>
                        <TableCell align="left">  {get_user_infos(department.department_manager, users)?.fullName} </TableCell>
                        <TableCell align="center">
                            <div className='documentsStatus_valide'  >
                                <div>
                                    <div><CheckIcon className="checkIcon" onClick={() => archive(id, department.id, false)} /></div>
                                    <div><CloseSharpIcon className="closeSharpIcon" onClick={() => archive(id, department.id, true)} /></div>
                                </div>
                                {state(department.archived)}
                            </div>
                        </TableCell>
                    </TableRow>
                ))
            }
        </>
    );
}


const Directions_departements_container = () => {
    const classes = useStyles();
    const [url_updated, setUrl_updated] = useState(null);
    let history = useHistory();

    const [data, setData] = useState(null);
    const [infos_type, setInfos_type] = useState("dir");
    const [add_infos_modal, setadd_infos_modal] = useState(false);
    const [update_infos, setupdate_infos] = useState(null);

    const [infos_updated, set_infos_updated] = useState(null);

    const [users, setUsers] = useState([]);
    const [all_directions, setall_directions] = useState([]);

    const [waiting, setWaiting] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataPerPage, setdataPerPage] = useState(6);
    const [data_count, setdata_count] = useState(0);

    useEffect(() => {
        setData(null);
        setdata_count(0);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let infos_type_tmp = infos_type;

        async function load_data() {
            if (urlParams.get('info')) {
                setInfos_type(urlParams.get('info'));
                infos_type_tmp = urlParams.get('info');
            }
            let page = (urlParams.get('page') ? urlParams.get('page') : 1);
            await setCurrentPage(page);
            if (users.length == 0) {
                await get_all_services().then((response) => {
                    setUsers(response.data);
                }).catch((error) => {
                    console.log(error.response);
                })
            }
            if (infos_type_tmp == 'dir') {
                await get_directions(page).then((response) => {
                    setData(response.data.data);
                    setdata_count(response.data.total);
                }).catch((error) => {
                    console.log(error.response);
                });
            } else {
                if (all_directions.length == 0) {
                    await get_all_directions().then((response) => {
                        setall_directions(response.data);
                    }).catch((error) => {
                        console.log(error.response);
                    })
                }
                await get_departments(page).then((response) => {
                    setData(response.data.data);
                    setdata_count(response.data.total);
                }).catch((error) => {
                    console.log(error.response);
                });
            }

        }

        load_data();
    }, [infos_updated, url_updated, history.location]);

    function archive(id, id_info, value) {
        setWaiting(true);
        let formData = new FormData();
        formData.append('id_info', id_info);
        formData.append('archive', value);
        /*archive_categorie(formData).then((response) => {
            let tmp_arr = [...categories];
            tmp_arr[id].archived = 1;
            setcategories(tmp_arr);
            setWaiting(false);
        }).catch((error) => {
            //console.log(error.response);
            setWaiting(false);
        })*/
    }

    function set_infos_types_page(value) {
        let path = history.location.pathname;
        history.push(path + "?info=" + value);
        setUrl_updated(value);
    }

    async function change_page(page) {
        await setCurrentPage(page);
        let path = history.location.pathname;
        let params = history.location.search;
        let search_params = params.split('&');
        let tmp_params = path;
        if (!params) history.push(path + "?page=" + page);
        else {
            for (let i in search_params) {
                if (search_params[i].includes("page=")) {
                    if (i == 0) tmp_params = tmp_params + "?page=" + page;
                    else tmp_params = tmp_params + "&page=" + page;
                } else {
                    if (i == 0) tmp_params = tmp_params + search_params[i];
                    else tmp_params = tmp_params + "&" + search_params[i];
                }
            }
            if (!tmp_params.includes("page=")) tmp_params = tmp_params + "&page=" + page;
            history.push(tmp_params);
        }
        await setUrl_updated(page);
    }

    return (
        <>
            {
                data == null
                    ? <Loading_animation_view />
                    : <div className='categories_list_container'>
                        <div className='categories_list_container_header'>
                            <div className='title_container'>
                                <FormControl variant="standard" className="header_form">
                                    <Select required value={infos_type}
                                        onChange={e => { set_infos_types_page(e.target.value) }} >
                                        <MenuItem value={"dir"} >Directions</MenuItem>
                                        <MenuItem value={"dep"} >Départements</MenuItem>
                                    </Select>
                                </FormControl>

                                <Button variant="contained" startIcon={<AddIcon className="my_icon" />} className={waiting ? "submit_but disabled_button" : "submit_but"} onClick={() => setadd_infos_modal(true)}>
                                    Ajouter
                                </Button>
                            </div>
                            <div className='select_container'>
                                {/* <FormControl variant='standard' className={classes.formControl} style={{width:"225px"}} >
                                <InputLabel>Etat de famille</InputLabel>
                                    <Select required
                                        value={categorie_state}
                                        onChange={e => {
                                            select_categorie_stat(e.target.value);
                                        }} name="Etat" >
                                        <MenuItem value={"default"} disabled>
                                            Etat de famille
                                        </MenuItem>
                                        <MenuItem value={"recent"}>Récent</MenuItem>
                                        <MenuItem value={"old"}>Ancien</MenuItem>
                                    </Select>
                            </FormControl> */}
                            </div>
                        </div>
                        <TableContainer className="categories_list_table" style={{ minWidth: "800px" }}>
                            <Table className={classes.table} aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {
                                            infos_type == "dir"
                                                ? directions_columns.map((column) => (
                                                    <TableCell key={column.id} align="left">{column.label}</TableCell>
                                                ))
                                                : departments_columns.map((column) => (
                                                    <TableCell key={column.id} align="left">{column.label}</TableCell>
                                                ))
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        data.length !== 0
                                            ?
                                            <>
                                                {
                                                    infos_type == "dir"
                                                        ? <Directions directions={data} archive={archive} setadd_infos_modal={setadd_infos_modal}
                                                            setupdate_infos={setupdate_infos} users={users} />
                                                        : <Departments departments={data} archive={archive} setadd_infos_modal={setadd_infos_modal}
                                                            setupdate_infos={setupdate_infos} users={users} all_directions={all_directions} />
                                                }

                                            </>
                                            : <div style={{ margin: "10px", fontSize: ".8rem", width: '100%', textAlign: "center", alignContent: "center" }}>Aucun infos</div>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {
                            data.length !== 0
                                ? <div className="pagination_container">
                                    <Pagination
                                        activePage={Number(currentPage)}
                                        itemsCountPerPage={dataPerPage}
                                        totalItemsCount={Number(data_count)}
                                        pageRangeDisplayed={4}
                                        onChange={change_page.bind(this)}
                                    />
                                </div>
                                : <></>
                        }
                    </div>
            }

            {
                add_infos_modal !== false
                    ? <Add_infos_modal add_infos_modal={add_infos_modal} setadd_infos_modal={setadd_infos_modal} set_infos_updated={set_infos_updated}
                        infos_type={infos_type} update_infos={update_infos} setupdate_infos={setupdate_infos} users={users} directions={all_directions} />
                    : <></>
            }

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default Directions_departements_container;